import { AFC, NFC } from './commons';

// This is the response we get from the endpoint that Rolando prepared.
export const NFL_TEAMS_GROUPS: { [key in typeof NFC | typeof AFC]: { [key: string]: { teamCityState: string, teamId: string, teamNick: string, teamFullName: string, teamAbbrName: string }[] } } = {
  'NFC': { //conference
    'NFC West': [ //division
      {
        'teamCityState': 'Arizona',
        'teamId': '3800',
        'teamNick': 'Cardinals',
        'teamFullName': 'Arizona Cardinals',
        'teamAbbrName': 'ARI'
      },
      {
        'teamCityState': 'Los Angeles Rams',
        'teamId': '2510',
        'teamNick': 'Rams',
        'teamFullName': 'Los Angeles Rams',
        'teamAbbrName': 'LA'
      },
      {
        'teamCityState': 'San Francisco',
        'teamId': '4500',
        'teamNick': '49ers',
        'teamFullName': 'San Francisco 49ers',
        'teamAbbrName': 'SF'
      },
      {
        'teamCityState': 'Seattle',
        'teamId': '4600',
        'teamNick': 'Seahawks',
        'teamFullName': 'Seattle Seahawks',
        'teamAbbrName': 'SEA'
      }
    ],
    'NFC South': [
      {
        'teamCityState': 'Atlanta',
        'teamId': '0200',
        'teamNick': 'Falcons',
        'teamFullName': 'Atlanta Falcons',
        'teamAbbrName': 'ATL'
      },
      {
        'teamCityState': 'Carolina',
        'teamId': '0750',
        'teamNick': 'Panthers',
        'teamFullName': 'Carolina Panthers',
        'teamAbbrName': 'CAR'
      },
      {
        'teamCityState': 'New Orleans',
        'teamId': '3300',
        'teamNick': 'Saints',
        'teamFullName': 'New Orleans Saints',
        'teamAbbrName': 'NO'
      },
      {
        'teamCityState': 'Tampa Bay',
        'teamId': '4900',
        'teamNick': 'Buccaneers',
        'teamFullName': 'Tampa Bay Buccaneers',
        'teamAbbrName': 'TB'
      }
    ],
    'NFC North': [
      {
        'teamCityState': 'Chicago',
        'teamId': '0810',
        'teamNick': 'Bears',
        'teamFullName': 'Chicago Bears',
        'teamAbbrName': 'CHI'
      },
      {
        'teamCityState': 'Detroit',
        'teamId': '1540',
        'teamNick': 'Lions',
        'teamFullName': 'Detroit Lions',
        'teamAbbrName': 'DET'
      },
      {
        'teamCityState': 'Green Bay',
        'teamId': '1800',
        'teamNick': 'Packers',
        'teamFullName': 'Green Bay Packers',
        'teamAbbrName': 'GB'
      },
      {
        'teamCityState': 'Minnesota',
        'teamId': '3000',
        'teamNick': 'Vikings',
        'teamFullName': 'Minnesota Vikings',
        'teamAbbrName': 'MIN'
      }
    ],
    'NFC East': [
      {
        'teamCityState': 'Dallas',
        'teamId': '1200',
        'teamNick': 'Cowboys',
        'teamFullName': 'Dallas Cowboys',
        'teamAbbrName': 'DAL'
      },
      {
        'teamCityState': 'New York Giants',
        'teamId': '3410',
        'teamNick': 'Giants',
        'teamFullName': 'New York Giants',
        'teamAbbrName': 'NYG'
      },
      {
        'teamCityState': 'Philadelphia',
        'teamId': '3700',
        'teamNick': 'Eagles',
        'teamFullName': 'Philadelphia Eagles',
        'teamAbbrName': 'PHI'
      },
      {
        'teamCityState': 'Washington',
        'teamId': '5110',
        'teamNick': 'Commanders',
        'teamFullName': 'Washington Commanders',
        'teamAbbrName': 'WAS'
      }
    ]
  },
  'AFC': {
    'AFC West': [
      {
        'teamCityState': 'Denver',
        'teamId': '1400',
        'teamNick': 'Broncos',
        'teamFullName': 'Denver Broncos',
        'teamAbbrName': 'DEN'
      },
      {
        'teamCityState': 'Kansas City',
        'teamId': '2310',
        'teamNick': 'Chiefs',
        'teamFullName': 'Kansas City Chiefs',
        'teamAbbrName': 'KC'
      },
      {
        'teamCityState': 'Los Angeles Chargers',
        'teamId': '4400',
        'teamNick': 'Chargers',
        'teamFullName': 'Los Angeles Chargers',
        'teamAbbrName': 'LAC'
      },
      {
        'teamCityState': 'Las Vegas',
        'teamId': '2520',
        'teamNick': 'Raiders',
        'teamFullName': 'Las Vegas Raiders',
        'teamAbbrName': 'LV'
      }
    ],
    'AFC East': [
      {
        'teamCityState': 'Buffalo',
        'teamId': '0610',
        'teamNick': 'Bills',
        'teamFullName': 'Buffalo Bills',
        'teamAbbrName': 'BUF'
      },
      {
        'teamCityState': 'Miami',
        'teamId': '2700',
        'teamNick': 'Dolphins',
        'teamFullName': 'Miami Dolphins',
        'teamAbbrName': 'MIA'
      },
      {
        'teamCityState': 'New England',
        'teamId': '3200',
        'teamNick': 'Patriots',
        'teamFullName': 'New England Patriots',
        'teamAbbrName': 'NE'
      },
      {
        'teamCityState': 'New York Jets',
        'teamId': '3430',
        'teamNick': 'Jets',
        'teamFullName': 'New York Jets',
        'teamAbbrName': 'NYJ'
      }
    ],
    'AFC North': [
      {
        'teamCityState': 'Baltimore',
        'teamId': '0325',
        'teamNick': 'Ravens',
        'teamFullName': 'Baltimore Ravens',
        'teamAbbrName': 'BAL'
      },
      {
        'teamCityState': 'Cincinnati',
        'teamId': '0920',
        'teamNick': 'Bengals',
        'teamFullName': 'Cincinnati Bengals',
        'teamAbbrName': 'CIN'
      },
      {
        'teamCityState': 'Cleveland',
        'teamId': '1050',
        'teamNick': 'Browns',
        'teamFullName': 'Cleveland Browns',
        'teamAbbrName': 'CLE'
      },
      {
        'teamCityState': 'Pittsburgh',
        'teamId': '3900',
        'teamNick': 'Steelers',
        'teamFullName': 'Pittsburgh Steelers',
        'teamAbbrName': 'PIT'
      }
    ],
    'AFC South': [
      {
        'teamCityState': 'Houston',
        'teamId': '2120',
        'teamNick': 'Texans',
        'teamFullName': 'Houston Texans',
        'teamAbbrName': 'HOU'
      },
      {
        'teamCityState': 'Indianapolis',
        'teamId': '2200',
        'teamNick': 'Colts',
        'teamFullName': 'Indianapolis Colts',
        'teamAbbrName': 'IND'
      },
      {
        'teamCityState': 'Jacksonville',
        'teamId': '2250',
        'teamNick': 'Jaguars',
        'teamFullName': 'Jacksonville Jaguars',
        'teamAbbrName': 'JAX'
      },
      {
        'teamCityState': 'Tennessee',
        'teamId': '2100',
        'teamNick': 'Titans',
        'teamFullName': 'Tennessee Titans',
        'teamAbbrName': 'TEN'
      }
    ]
  }
};

export const NCAA_TEAMS = [
  {
    'teamCityState': '',
    'teamId': '194',
    'teamNick': 'Football',
    'teamFullName': 'OSU Football',
    'teamAbbrName': 'OSU'
  },
  {
    'teamCityState': '',
    'teamId': '19410',
    'teamNick': 'Lacrosse',
    'teamFullName': 'OSU Lacrosse',
    'teamAbbrName': 'OSU'
  }
];

export const ZEBRA_TEAMS = [
  {
    'teamCityState': 'Mobile',
    'teamId': '9600',
    'teamNick': 'North',
    'teamFullName': 'SB-North',
    'teamAbbrName': 'SBN'
  },
  {
    'teamCityState': 'Mobile',
    'teamId': '9700',
    'teamNick': 'South',
    'teamFullName': 'SB-South',
    'teamAbbrName': 'SBS'
  },
  {
    'teamCityState': 'Mobile',
    'teamId': '7600',
    'teamNick': 'East',
    'teamFullName': 'Shrine-East',
    'teamAbbrName': 'SGE'
  },
  {
    'teamCityState': 'Mobile',
    'teamId': '7700',
    'teamNick': 'West',
    'teamFullName': 'Shrine-West',
    'teamAbbrName': 'SGW'
  }
];

// replace to getDataTeam
export const TEAMS_NAMES = [
  { name: 'Baltimore Ravens', short: 'BAL' },
  { name: 'Cincinnati Bengals', short: 'CIN' },
  { name: 'Cleveland Browns', short: 'CLE' },
  { name: 'Pittsburgh Steelers', short: 'PIT' },
  { name: 'Buffalo Bills', short: 'BUF' },
  { name: 'Miami Dolphins', short: 'MIA' },
  { name: 'New England Patriots', short: 'NE' },
  { name: 'New York Jets', short: 'NYJ' },
  { name: 'Houston Texans', short: 'HOU' },
  { name: 'Indianapolis Colts', short: 'IND' },
  { name: 'Jacksonville Jaguars', short: 'JAX' },
  { name: 'Tennessee Tennessee', short: 'TEN' },
  { name: 'Denver Broncos', short: 'DEN' },
  { name: 'Kansas City Chiefs', short: 'KC' },
  { name: 'Los Angeles Chargers', short: 'LAC' },
  { name: 'Las Vegas Raiders', short: 'LV' },
  { name: 'Chicago Bears', short: 'CHI' },
  { name: 'Detroit Lions', short: 'DET' },
  { name: 'Green Bay Packers', short: 'GB' },
  { name: 'Minnesota Vikings', short: 'MIN' },
  { name: 'Dallas Cowboys', short: 'DAL' },
  { name: 'New York Giants', short: 'NYG' },
  { name: 'Philadelphia Eagles', short: 'PHI' },
  { name: 'Washington Commanders', short: 'WAS' },
  { name: 'Atlanta Falcons', short: 'ATL' },
  { name: 'Carolina Panthers', short: 'CAR' },
  { name: 'New Orleans Saints', short: 'NO' },
  { name: 'Tampa Bay Buccaneers', short: 'TB' },
  { name: 'Arizona Cardinals', short: 'ARI' },
  { name: 'Los Angeles Rams', short: 'LA' },
  { name: 'Los Angeles Rams', short: 'LAR' },
  { name: 'San Francisco 49ers', short: 'SF' },
  { name: 'Seattle Seahawks', short: 'SEA' },
  { name: 'Ohio State University', short: 'OSU' }
];

export const TEAMS_ALL = [
  {
    teamName: 'Ohio State Buckeyes',
    teamId: '19410',
    league: 'ncaa-mlax',
    teamNick: 'MLAX',
    teamAbbr: 'OSU'
  },
  {
    teamName: 'Clemson Tigers',
    teamId: '0228',
    league: 'ncaa-fbs',
    teamAbbr: 'Clemson',
    teamNick: 'Tigers'
  },
  {
    teamName: 'Michigan State Spartans',
    teamId: '0127',
    league: 'ncaa-fbs',
    teamAbbr: 'Michigan State',
    teamNick: 'Spartans'
  },
  {
    teamName: 'Tennessee Volunteers',
    teamId: '2633',
    league: 'ncaa-fbs',
    teamAbbr: 'TENN',
    teamNick: 'Volunteers'
  },
  {
    teamName: 'Washington Huskies',
    teamId: '0264',
    league: 'ncaa-fbs',
    teamAbbr: 'NCAA-WAS',
    teamNick: 'Huskies'
  },
  {
    teamName: 'Arizona Cardinals',
    teamId: '3800',
    league: 'nfl',
    teamAbbr: 'ARI',
    teamNick: 'Cardinals'
  },
  {
    teamName: 'Atlanta Falcons',
    teamId: '0200',
    league: 'nfl',
    teamAbbr: 'ATL',
    teamNick: 'Falcons'
  },
  {
    teamName: 'Baltimore Ravens',
    teamId: '0325',
    league: 'nfl',
    teamAbbr: 'BAL',
    teamNick: 'Ravens'
  },
  {
    teamName: 'Buffalo Bills',
    teamId: '0610',
    league: 'nfl',
    teamAbbr: 'BUF',
    teamNick: 'Bills'
  },
  {
    teamName: 'Carolina Panthers',
    teamId: '0750',
    league: 'nfl',
    teamAbbr: 'CAR',
    teamNick: 'Panthers'
  },
  {
    teamName: 'Chicago Bears',
    teamId: '0810',
    league: 'nfl',
    teamAbbr: 'CHI',
    teamNick: 'Bears'
  },
  {
    teamName: 'Cincinnati Bengals',
    teamId: '0920',
    league: 'nfl',
    teamAbbr: 'CIN',
    teamNick: 'Bengals'
  },
  {
    teamName: 'Cleveland Browns',
    teamId: '1050',
    league: 'nfl',
    teamAbbr: 'CLE',
    teamNick: 'Browns'
  },
  {
    teamName: 'Dallas Cowboys',
    teamId: '1200',
    league: 'nfl',
    teamAbbr: 'DAL',
    teamNick: 'Cowboys'
  },
  {
    teamName: 'Denver Broncos',
    teamId: '1400',
    league: 'nfl',
    teamAbbr: 'DEN',
    teamNick: 'Broncos'
  },
  {
    teamName: 'Detroit Lions',
    teamId: '1540',
    league: 'nfl',
    teamAbbr: 'DET',
    teamNick: 'Lions'
  },
  {
    teamName: 'Green Bay Packers',
    teamId: '1800',
    league: 'nfl',
    teamAbbr: 'GB',
    teamNick: 'Packers'
  },
  {
    teamName: 'Houston Texans',
    teamId: '2120',
    league: 'nfl',
    teamAbbr: 'HOU',
    teamNick: 'Texans'
  },
  {
    teamName: 'Indianapolis Colts',
    teamId: '2200',
    league: 'nfl',
    teamAbbr: 'IND',
    teamNick: 'Colts'
  },
  {
    teamName: 'Jacksonville Jaguars',
    teamId: '2250',
    league: 'nfl',
    teamAbbr: 'JAC',
    teamNick: 'Jaguars'
  },
  {
    teamName: 'Kansas City Chiefs',
    teamId: '2310',
    league: 'nfl',
    teamAbbr: 'KC',
    teamNick: 'Chiefs'
  },
  {
    teamName: 'Las Vegas Raiders',
    teamId: '2520',
    league: 'nfl',
    teamAbbr: 'LV',
    teamNick: 'Raiders'
  },
  {
    teamName: 'Miami Dolphins',
    teamId: '2700',
    league: 'nfl',
    teamAbbr: 'MIA',
    teamNick: 'Dolphins'
  },
  {
    teamName: 'Minnesota Vikings',
    teamId: '3000',
    league: 'nfl',
    teamAbbr: 'MIN',
    teamNick: 'Vikings'
  },
  {
    teamName: 'New England Patriots',
    teamId: '3200',
    league: 'nfl',
    teamAbbr: 'NE',
    teamNick: 'Patriots'
  },
  {
    teamName: 'New Orleans Saints',
    teamId: '3300',
    league: 'nfl',
    teamAbbr: 'NO',
    teamNick: 'Saints'
  },
  {
    teamName: 'New York Giants',
    teamId: '3410',
    league: 'nfl',
    teamAbbr: 'NYG',
    teamNick: 'Giants'
  },
  {
    teamName: 'Philadelphia Eagles',
    teamId: '3700',
    league: 'nfl',
    teamAbbr: 'PHI',
    teamNick: 'Eagles'
  },
  {
    teamName: 'Pittsburgh Steelers',
    teamId: '3900',
    league: 'nfl',
    teamAbbr: 'PIT',
    teamNick: 'Steelers'
  },
  {
    teamName: 'San Francisco 49ers',
    teamId: '4501',
    league: 'nfl',
    teamAbbr: 'CC',
    teamNick: 'Test 49ers'
  },
  {
    teamName: 'San Francisco 49ers',
    teamId: '4500',
    league: 'nfl',
    teamAbbr: 'SF',
    teamNick: '49ers'
  },
  {
    teamName: 'Seattle Seahawks',
    teamId: '4600',
    league: 'nfl',
    teamAbbr: 'SEA',
    teamNick: 'Seahawks'
  },
  {
    teamName: 'Los Angeles Rams',
    teamId: '2510',
    league: 'nfl',
    teamAbbr: 'LA',
    teamNick: 'Rams'
  },
  {
    teamName: 'Tampa Bay Buccaneers',
    teamId: '4900',
    league: 'nfl',
    teamAbbr: 'TB',
    teamNick: 'Buccaneers'
  },
  {
    teamName: 'Tennessee Titans',
    teamId: '2100',
    league: 'nfl',
    teamAbbr: 'TEN',
    teamNick: 'Titans'
  },
  {
    teamName: 'Washington Commanders',
    teamId: '5110',
    league: 'nfl',
    teamAbbr: 'WAS',
    teamNick: 'Commanders'
  },
  {
    teamName: 'New York Jets',
    teamId: '3430',
    league: 'nfl',
    teamAbbr: 'NYJ',
    teamNick: 'Jets'
  },
  {
    teamName: 'Los Angeles Chargers',
    teamId: '4400',
    league: 'nfl',
    teamAbbr: 'LAC',
    teamNick: 'Chargers'
  },
  {
    teamName: 'Ohio State Buckeyes',
    teamId: '194',
    league: 'ncaa-fbs',
    teamNick: 'FB',
    teamAbbr: 'OSU'
  },
  {
    teamName: 'SB-North',
    teamId: '9600',
    league: 'ncaa-fbs',
    teamAbbr: 'SBN',
    teamNick: ''
  },
  {
    teamName: 'SB-North',
    teamId: '9600',
    league: 'ncaa-fbs',
    teamAbbr: 'SBN',
    teamNick: 'SBN'
  },
  {
    teamName: 'Shrine-East',
    teamId: '7600',
    league: 'ncaa-fbs',
    teamAbbr: 'SGE',
    teamNick: 'East'
  },
  {
    teamName: 'SB-South',
    teamId: '9700',
    league: 'ncaa-fbs',
    teamAbbr: 'SBS',
    teamNick: ''
  },
  {
    teamName: 'SB-South',
    teamId: '9700',
    league: 'ncaa-fbs',
    teamAbbr: 'SBS',
    teamNick: 'SBS'
  },
  {
    teamName: 'Shrine-West',
    teamId: '7700',
    league: 'ncaa-fbs',
    teamAbbr: 'SGW',
    teamNick: 'West'
  },
  {
    teamName: 'Zebra Practice',
    teamId: '9500',
    league: 'nfl',
    teamAbbr: 'CC',
    teamNick: 'Zebra Team'
  },
  //ZEBRA INTERNAL GROUPS
  {
    teamName: 'Group 1',
    teamId: '1000',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 1'
  },
  {
    teamName: 'Group 2',
    teamId: '1001',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 2'
  },
  {
    teamName: 'Group 3',
    teamId: '1002',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 3'
  },
  {
    teamName: 'Group 4',
    teamId: '1003',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 4'
  },
  {
    teamName: 'Group 5',
    teamId: '1004',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 5'
  },
  {
    teamName: 'Group 6',
    teamId: '1005',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 6'
  },
  {
    teamName: 'Group 7',
    teamId: '1006',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 7'
  },
  {
    teamName: 'Group 8',
    teamId: '1007',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 8'
  },
  {
    teamName: 'Group 9',
    teamId: '1008',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 9'
  },
  {
    teamName: 'Group 10',
    teamId: '1009',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 10'
  },
  {
    teamName: 'Group 11',
    teamId: '1010',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 11'
  },
  {
    teamName: 'Group 12',
    teamId: '1011',
    teamAbbr: 'ZEBRA',
    teamNick: 'Group 12'
  }
];
// export const teamsNames = ['Baltimore Ravens', 'Cincinnati Bengals', 'Cleveland Browns', 'Pittsburgh Steelers',
//   'Buffalo Bills', 'Miami Dolphins', 'New England Patriots', 'New York Jets',
//   'Houston Texans', 'Indianapolis Colts', 'Jacksonville Jaguars', 'Tennessee Tennessee',
//   'Denver Broncos', 'Kansas City Chiefs', 'Los Angeles Chargers', 'Oakland Raiders',
//   'Chicago Bears', 'Detroit Lions', 'Green Bay Packers', 'Minnesota Vikings',
//   'Dallas Cowboys', 'New York Giants', 'Philadelphia Eagles', 'Washington Redskins',
//   'Atlanta Falcons', 'Carolina Panthers', 'New Orleans Saints', 'Tampa Bay Buccaneers',
//   'Arizona Cardinals', 'Los Angeles Rams', 'San Francisco 49ers', 'Seattle Seahawks'];

// export const teamsShortNames = ['ARI', 'ATL', 'BAL', 'BUF', 'CAR', 'CHI', 'CIN', 'CLE', 'DAL', 'DEN', 'DET', 'GB', 'HOU', 'IND', 
//'JAC', 'JAX', 'KC', 'LAC', 'LA', 'MIA', 'MIN', 'NE', 'NO', 'NYG', 'NYJ', 'OAK', 'ORL', 'PHI', 'PIT', 'SD', 'SF', 'SEA', 'STL', 'TB', 'TEN', 'WAS'];

export const TEAMS_COLORS: { [key: string]: { text: string, line: string } } = {
  ARI: { text: '#97233F', line: '#FFB612' },
  ATL: { text: '#A71930', line: '#000000' },
  BAL: { text: '#241773', line: '#9E7C0C' },
  BUF: { text: '#00338D', line: '#C60C30' },
  CAR: { text: '#0085CA', line: '#101820' },
  CHI: { text: '#0B162A', line: '#C83803' },
  CIN: { text: '#FB4F14', line: '#000000' },
  CLE: { text: '#311D00', line: '#FF3C00' },
  DAL: { text: '#041E42', line: '#003594' },
  DEN: { text: '#FB4F14', line: '#002244' },
  DET: { text: '#0076B6', line: '#B0B7BC' },
  GB: { text: '#203731', line: '#FFB612' },
  HOU: { text: '#03202F', line: '#A71930' },
  IND: { text: '#002C5F', line: '#A2AAAD' },
  JAC: { text: '#006778', line: '#D7A22A' },
  JAX: { text: '#006778', line: '#D7A22A' },
  KC: { text: '#E31837', line: '#FFB81C' },
  LAC: { text: '#0080C6', line: '#FFC20E' },
  LA: { text: '#003594', line: '#FFD100' },
  LAR: { text: '#003594', line: '#FFD100' },
  MIA: { text: '#008E97', line: '#F26A24' },
  MIN: { text: '#4F2683', line: '#FFC62F' },
  NE: { text: '#002244', line: '#C60C30' },
  NO: { text: '#101820', line: '#D3BC8D' },
  NYG: { text: '#0B2265', line: '#A71930' },
  NYJ: { text: '#003F2D', line: '#999999' },
  OAK: { text: '#000000', line: '#A5ACAF' },
  LV: { text: '#000000', line: '#A5ACAF' },
  ORL: { text: '#101820', line: '#D3BC8D' },
  PHI: { text: '#004C54', line: '#A5ACAF' },
  PIT: { text: '#101820', line: '#FFB612' },
  SD: { text: '#0080C6', line: '#FFC20E' },
  SF: { text: '#AA0000', line: '#B3995D' },
  SEA: { text: '#002244', line: '#69BE28' },
  STL: { text: '#0080C6', line: '#866D4B' },
  TB: { text: '#D50A0A', line: '#B1BABF' },
  TEN: { text: '#002A5C', line: '#4495D1' },
  WAS: { text: '#773141', line: '#FFB612' },
  OSU: { text: '#BB0000', line: '#000000' },
  default: { text: '#FFFFFF', line: '#000000' }
};
